module.exports = __webpack_public_path__ + "img/logo.f9e8039d.svg";